import React, { useEffect, useState } from "react";
import useDidMountEffect from "../../../customHooks/useDidMountEffect";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  setModalChild,
  setModalState,
} from "../../../state/actions/modalAction";
import { useTranslation } from "react-i18next";
import heLocale from "date-fns/locale/he";
import arLocale from "date-fns/locale/ar";
import { DatePicker, LocalizationProvider, MobileDatePicker  } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import CustomInput from "../../../components/CustomInput/CustomInput";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  Stack,
} from "@mui/material";
import HelpCircleIcon from "../../../components/HelpCircleIcon/HelpCircleIcon";
import IdDateInfoPopup from "../../../components/IdDateInfoPopup/IdDateInfoPopup";
import RenderInputError from "../../Login/RenderInputError/RenderInputError";
import NextStepButton from "../../../components/NextStepButton/NextStepButton";
import RegFirstStepValues from "../../../entities/RegFirstStepValues";
import CircleLoading from "../../../components/CircleLoading/CircleLoading";
import { setIdDate, setUserId } from "../../../state/actions/UserActions";
import {
  OtpSendRegister,
  otpSendRegisterUtil,
} from "../../../services/OtpSendRegister";
import { getUserFunds } from "../../../services/getUserFunds";
import { GetMemberFunds } from "../../../services/GetMemberFunds";
import ErrorPopup from "../../../components/ErrorPopup/ErrorPopup";
import "./RegFirstStep.scss";
import HebrewPdf from "../../../assets/pdf/sachir_shimush.pdf";
import "./RegFirstStep.scss";
import { isEnterPress } from "../../../utils/helpers/accessibilityUtil";
import useInputFocus from "../../../customHooks/useInputFocus";
import EventIcon from '@mui/icons-material/Event';

export const localeMap = {
  he: heLocale,
  ar: arLocale,
};


  
export const getRequestFormatDate = (inputFormat?: Date) => {
  if(inputFormat == undefined ) return inputFormat
  function pad(s:any) { return (s < 10) ? '0' + s : s; }
  var d = inputFormat
  return [d.getFullYear(), pad(d.getMonth()+1),pad(d.getDate()) ].join('-')
};

export const maskMap = {
  he: "dd/MM/yyyy",
  ar: "dd/MM/yyyy",
};

const RegFirstStep = (props: {
  setActiveStep: (arg0: number) => void;
  activeStep: number;
  setPhoneAndEmailError: (arg0: boolean) => void;
  registerBankAccountTokenNum:(arg:string)=>void;
}) => {
  const validate = (values: RegFirstStepValues) => {
    const errors: any = {};

    if (!values.enteredIdNumber) {
      errors.enteredIdNumber = t("Login.idNullError");
    } else if (
      !(
        values.enteredIdNumber.length >= 2 && values.enteredIdNumber.length <= 9
      )
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    } else if (
      // check for every digit that is a number
      values.enteredIdNumber
        .split("")
        .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
        .length !== values.enteredIdNumber.length
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    } else if (
      // handle all zeros case
      values.enteredIdNumber
        .split("")
        .filter((digit: string) => parseInt(digit) === 0).length ===
      values.enteredIdNumber.length
    ) {
      errors.enteredIdNumber = t("Login.idLengthError");
    }

    if (!values.firstChecked) {
      errors.firstChecked = t("RegFirstStep.checkboxError");
    }

    if (!values.secondChecked) {
      errors.secondChecked = t("RegFirstStep.checkboxError");
    }

    if (!dateValue) {
      errors.idDate = t("RegFirstStep.dataValueError");
    }

    return errors;
  };

  const { t, i18n } = useTranslation("common");
  const dispatch = useDispatch();
  const [locale, setLocale] = useState<keyof typeof maskMap>("he");
  const [dateValue, setDateValue] = useState<any>("");
  const [isOtpLoading, setOtpLoading] = useState<boolean>(false);
  const [submitError, setSubmitError] = useState<boolean>(false);
  const [maxRequestsError, setMaxRequestsError] = useState<boolean>(false);
  const [clickbtnsub , setClickbtnsub] = useState<boolean>(false);
  const [open , setOpen] = useState<boolean>(false);

  const [isAlreadyRegisterError, setAlreadyRegisterError] =
    useState<boolean>(false);
  const [dateValueBlured, setDateBlured] = useState({
    status: false,
    count: 0,
  });

  const setOtpResult = (
    otpMode: string,
    cellPhoneNumber?: string,
    email?: string
  ) => {
    sessionStorage.setItem("otpMode", otpMode);
    cellPhoneNumber?.length &&
      sessionStorage.setItem("cellPhoneNumber", cellPhoneNumber);
    email?.length && sessionStorage.setItem("email", email);
  };

  const formik = useFormik({
    initialValues: {
      enteredIdNumber: "",
      idDate: "", // in use only for formik validation
      firstChecked: false,
      secondChecked: false,
    },
    validate,
    onSubmit: async (values: RegFirstStepValues) => {
      if (values) {
        setOtpLoading(true);
        const idDate = getRequestFormatDate(dateValue);
        if(idDate == undefined ) return;
        dispatch(setIdDate(idDate));
        const submitStatus: any = await OtpSendRegister(
          values.enteredIdNumber,
          idDate
        );
        if (otpSendRegisterUtil.isSuccess(submitStatus)) {
          const { otpMode, cellPhoneNumber, email } = submitStatus;
          setOtpResult(otpMode, cellPhoneNumber, email);
          localStorage.setItem("userId", values.enteredIdNumber); // set user id to local storage
          dispatch(setUserId(values.enteredIdNumber));
          setOtpLoading(false);
          props.setActiveStep(props.activeStep + 1);
        } else if (submitStatus.registerBankAccountTokenNum) {
            localStorage.setItem("userId", values.enteredIdNumber); // set user id to local storage
            dispatch(setUserId(values.enteredIdNumber));
            setOtpLoading(false);
            props.registerBankAccountTokenNum(submitStatus.registerBankAccountTokenNum)
            props.setPhoneAndEmailError(true);
            props.setActiveStep(props.activeStep + 1);
        } else if (otpSendRegisterUtil.isMaxServerRequestsError(submitStatus)) {
          submitError && setSubmitError(false);
          isAlreadyRegisterError && setAlreadyRegisterError(false);
          setMaxRequestsError(true);
        } else if (otpSendRegisterUtil.isAlreadyRegisteredError(submitStatus)) {
          submitError && setSubmitError(false);
          maxRequestsError && setMaxRequestsError(false);
          setAlreadyRegisterError(true);
        } else {
          formik.resetForm({
            values: { ...values, firstChecked: false, secondChecked: false },
          });
          maxRequestsError && setMaxRequestsError(false);
          isAlreadyRegisterError && setAlreadyRegisterError(false);
          setSubmitError(true);
        }
        setOtpLoading(false);
      }
    },
  });



  useDidMountEffect(() => {
    if (i18n.language === "he") {
      setLocale("he");
    } else if (i18n.language === "ar") {
      setLocale("ar");
    }
    formik.validateForm(); // need to check it out
  }, [i18n.language]);

  const handleIdBlured = () => {
    setDateBlured((value) => {
      return {
        status: true,
        count: (value.count += 1),
      };
    });
  };

  const openIdDateInfoPopup = () => {
    dispatch(setModalState(true));
    dispatch(setModalChild(<IdDateInfoPopup size={"m"} />));
  };

  const openErrorPopup = () => {
    dispatch(setModalState(true));
    dispatch(
      setModalChild(
        <ErrorPopup size="m" label={t("general.error")} center={true} />
      )
    );
  };

  const getTermsOfUse = () => {
    return HebrewPdf;
  };


  const InputFocus = useInputFocus(formik.errors, formik.submitCount, clickbtnsub);
  useEffect(() => {
    if (InputFocus) {
      setClickbtnsub(false);
    }
  }, [InputFocus, clickbtnsub]);

  return isOtpLoading ? (
    <CircleLoading loadingLabel={t("Login.codeOneTheWay")} />
  ) : (
    <form onSubmit={formik.handleSubmit}>
      <CustomInput
      // autoFocus={true}
        formik={formik}
        fullWidth={true}
        keyString="enteredIdNumber"
        inputLabel={`${t("Login.idLabel")}*`}
        tooltipLabel={t("Login.idTooltipLabel")}
        withIcon={true}
        maxLength={9}
        withTooltip={true}
        space={false}
        htmlFor={"enteredIdNumber"}
        ariaDescribedby={"enteredIdNumber"}
        aria-required="true"
      />
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        locale={localeMap[locale]}
      >
        <DatePicker
          label={`${t("RegFirstStep.dateValueLabel")}*`}
          value={dateValue}
          okText={t("general.accept")}
          cancelText={t("general.cancel")}
          maxDate={new Date()}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}        
          views={["year", "month", "day"]}
          inputFormat="dd/MM/yyyy"
          
          onChange={(newValue) => {
            newValue && setDateValue(newValue);
          }}
               
          showToolbar={false}
          renderInput={(params) => (
            <div className="CustomInput">
              <TextField
              id="issueDateId"
                {...params}
                fullWidth
                inputProps={{
                  ...params.inputProps,
                  placeholder: `${new Date().toLocaleDateString('en-gb')}`,
                  'aria-required': "true",
                }}

                aria-required="true"
                className={`CustomInput date-value-cursor ${(formik.submitCount && !dateValue) ||
                    (!dateValue &&
                      dateValueBlured.status &&
                      dateValueBlured.count > 1)
                    ? "login-input-error"
                    : "input-b"
                  }`}
                onBlur={handleIdBlured}
                InputProps={{
                  endAdornment: (
                    <>
                      <InputAdornment position="end">
                      <IconButton edge="end" onClick={(e) => setOpen(true)}>
                        <EventIcon />
                      </IconButton>
                    </InputAdornment>
                      <InputAdornment position="end">
                        <IconButton edge="end" onClick={openIdDateInfoPopup}>
                          <HelpCircleIcon />
                        </IconButton>
                      </InputAdornment>
                    </>
                  ),
                }}
              />
              {(formik.submitCount && !dateValue) ||
                (!dateValue && dateValueBlured.status && dateValueBlured.count > 1) ? (
                <RenderInputError id={"issueDateId"} errorLabel={t("RegFirstStep.dataValueError")} />
              ) : null}
            </div>
          )}
        />
      </LocalizationProvider>
      <FormGroup sx={{ marginTop: "25px" }}>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              sx={{
                "&.Mui-checked": {
                  color: "#0250C1",
                },
                "&.Mui-focusVisible": {
                  outline: "3px solid #10059f",
                  borderRadius: "0px"
                },
                color: "#aaa7a7",       
                padding: "3px 0px",
                margin: "0px 10px"
              }}
              id="firstChecked"
              name="firstChecked"
              value={formik.values.firstChecked}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          }
          label={
            <span
              className="register-checkbox-label"
              onClick={(e) => e.preventDefault()}
            >
              {t("RegFirstStep.firstCheckboxLabel1")}{" "}
              <u
                onClick={() => window.open(getTermsOfUse())}
                onKeyPress={(event) =>
                  isEnterPress(event) && window.open(getTermsOfUse())
                }
                tabIndex={0}
              >
                {t("RegFirstStep.firstCheckboxLabel2")}
              </u>{" "}
              {t("RegFirstStep.firstCheckboxLabel3")}
            </span>
          }
          sx={{
            marginRight: "initial",
            marginLeft: "initial",
            padding: "initial",
            alignItems: "flex-start"
          }}
        />
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              sx={{
                "&.Mui-checked": {
                  color: "#0250C1",
                },
                "&.Mui-focusVisible": {
                  outline: "3px solid #10059f",
                  borderRadius: "0px"
                },
                color: "#aaa7a7",
                padding: "3px 0px",
                margin: "0px 10px"
              }}
              id="secondChecked"
              name="secondChecked"
              value={formik.values.secondChecked}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          }
          label={
            <span className="register-checkbox-label">
              {t("RegFirstStep.secondCheckboxLabel")}
            </span>
          }
          sx={{
            marginTop: "22px",
            marginRight: "initial",
            marginLeft: "initial",
            padding: "initial",
            alignItems: "flex-start",
          }}
        />
      </FormGroup>
      <NextStepButton text={t("general.next")} onclick={(val)=>{setClickbtnsub(val);}}/>
      <div>
      {(formik.errors.firstChecked || formik.errors.secondChecked) &&
        formik.touched.firstChecked &&
        formik.touched.secondChecked && (
            <RenderInputError
              errorLabel={
                formik.errors.firstChecked
                  ? formik.errors.firstChecked
                  : formik.errors.secondChecked
              }
              style={{bottom:'25px'}}
            />
        )}
      {submitError || maxRequestsError || isAlreadyRegisterError ? (
          <RenderInputError
            errorLabel={
              maxRequestsError
                ? t("BankAccountVerify.sendAgainError")
                : isAlreadyRegisterError
                  ? t("RegFirstStep.alreadyRegisterError")
                  : t("Login.submitError")
            }
            style={{bottom:0}}
          />
      ) : null}
      </div>
    </form>
  );
};

export default RegFirstStep;


